<template>
  <div>
    <el-dialog :append-to-body="true"
               :title="dialogTitle"
               :visible.sync="isShowDialog"
               :before-close="closeDialog"
               center
               :close-on-click-modal="false"
               :modal="false"
               v-dialog-drag>
      <div class="infinite-list"
           v-infinite-scroll="dataLoad"
           :infinite-scroll-distance="10"
           style="overflow:auto;background-color: #cccccc;height: 25rem;color: #FFFFFF;"
           ref="chatmsglist">
        <div v-for="(item, index) in messageList" :key="index"
             class="infinite-list-item message-item">
          <div v-if="item.activeUserName !== item.sendUserName" style="overflow: auto;width: 100%;">
            <div style="float:right;width: 60%;display: inline-flex;justify-content: right;align-items: flex-start;">
              <div style="margin-right: 2%;font-size: large;">
                <div v-if="item.msgType == 0">
                  {{ item.message }}
                </div>
                <div v-else-if="item.msgType == 1">
                  <el-image
                      style="width: 100%; height: 100%"
                      :src="item.message"
                      :preview-src-list="buildImageList(item.message)">
                  </el-image>
                </div>
                <div v-else>
                </div>
                <div style="color: #acacac;font-size: x-small;float: right;">{{ item.msgStatus ? "已读" : "未读" }}</div>
              </div>
              <div style="width: 4.5rem">
                <el-avatar shape="square" :src="sendUrl" alt="用户头像" style="width: 2.5rem"></el-avatar>
              </div>
            </div>
          </div>
          <div v-else style="overflow: auto;width: 100%;">
            <div style="float:left;width: 60%;display: inline-flex;justify-content: left;align-items: flex-start;">
              <div style="width: 4.5rem">
                <el-avatar shape="square" :src="reciveUrl" alt="用户头像"></el-avatar>
              </div>
              <div style="margin-left: 2%;font-size: large;">
                <div v-if="item.msgType == 0">
                  {{ item.message }}
                </div>
                <div v-else-if="item.msgType == 1">
                  <el-image
                      style="width: 100%; height: 100%"
                      :src="item.message"
                      :preview-src-list="buildImageList(item.message)">
                  </el-image>
                </div>
                <div v-else>
                </div>
                <div style="color: #acacac;font-size: x-small">{{ item.msgStatus ? "已读" : "未读" }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-row :gutter="5" style="margin-top: 1%;">
        <el-col :span="18">
          <el-input type="text" placeholder="发送消息" v-model="msgTextContent" clearable size="small" @keyup.enter.native="buildSendTextMsg"></el-input>
        </el-col>
        <el-col :span="6">
          <div class="send_tool">
            <button type="button" @click="buildSendTextMsg" style="font-size: 90%" >发送</button>
            <el-upload style="margin-left: 2%;font-size: 90%;"
                action="http://service.8jg.top/imessagectr/file/upload"
                :headers="myheader"
                :show-file-list="false"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                :on-success="handleReviewSuccess">
               <button type="button" style="margin-left: 2%;font-size: 90%;">图片<i class="el-icon-camera el-icon--right"></i></button>
            </el-upload>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import {InfiniteScroll} from "element-ui"
import * as Util from "../../lib/utils";
import B2cWebSocket from "../../lib/websocket";
import {queryUserMsgList} from "../../api/b2cbusiness/b2c_admin";
import {getJwtToken} from "../../lib/utils";

export default {
  name: "ChatMessageDialog",
  directives: {InfiniteScroll},
  data() {
    return {
      myheader: {
        JWTHeaderName: ""
      },
      socketHander: null,
      dialogTitle: "",
      isShowDialog: false,
      messageList: [],
      sendUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      reciveUrl: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
      msgTextContent: ""
    }
  },
  mounted() {
    this.socketHander = new B2cWebSocket({url:"ws://service.8jg.top/imessage/"+Util.getTokenUser()+"/"+this.dialogTitle});
    this.myheader.JWTHeaderName = getJwtToken();
    this.socketHander.onmessage(this.onMessage);
    this.getData();
  },
  computed: {},
  methods: {
    onMessage(res){
      if (res != "b2c_heart" && res != "上线成功！"){
        let msgObject = JSON.parse(res);
        if (msgObject.activeUserName == null){
          msgObject.activeUserName = this.dialogTitle;
        }
        this.messageList.push(msgObject);
        console.log(this.messageList)
        this.$forceUpdate();
        this.$nextTick(()=>{
          this.$refs.chatmsglist.scrollTop= this.$refs.chatmsglist.scrollHeight
        })
      }
    },
    handleReviewSuccess(res, file) {
      this.socketHander.sendMsg(JSON.stringify({
        receiveUserName:this.dialogTitle,
        sendUserName:Util.getTokenUser(),
        msgType: 1,
        message: res.data
      }));
    },
    buildSendTextMsg(){
      console.log("text message")
      if (!Util.isStrEmpty(this.msgTextContent)){
        this.socketHander.sendMsg(JSON.stringify({
          receiveUserName:this.dialogTitle,
          sendUserName:Util.getTokenUser(),
          msgType: 0,
          message: this.msgTextContent
        }));
        this.msgTextContent = "";
      }
    },
    buildImageList(image) {
      return new Array(image);
    },
    closeDialog() {
      this.isShowDialog = false;
    },
    getData(){
      queryUserMsgList({activeUserName:this.dialogTitle}).then(res=>{
        if (res.success){
          this.messageList.push(...res.data);
        }
      });
    },
    dataLoad() {

    }
  },
  destroyed() {
    this.socketHander.close();
    console.log("destroyed");
  }
}
</script>

<style lang="scss" scoped>
.message-item {
  margin: 0.35rem;
  overflow: hidden;
}

.send_tool {
  height: 33px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  button {
    height: 33px;
    font-size: 0.1rem;
    background-color: #409EFF;
    color: white;
    border: 0 solid;
  }
}

.el-dialog__wrapper {
  pointer-events: none;
}

/deep/.el-dialog {
  width: 25%;
}

/deep/ .el-dialog__header {
  padding: 20px 20px 10px;
  background: blue;
  border-radius: 5px 5px 0 0;
}

/deep/ .el-dialog__title {
  color: white;
}

/deep/ .el-dialog--center {
  pointer-events: auto;
}

/deep/ .el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 0.1rem;
}

/deep/ .el-dialog__body {
  background-color: white;
}
</style>
